<template>
  <div class="phone">
    <!-- 轮播 Start -->
    <div class="htmleaf-container">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
            <img class="bannerradius" :src="item.coverUrl" />
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播 End -->

    <!--作品 Start-->
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item,index) in compotiiton"
        :key="index"
        :label="item.title"
        :name="item.title"
      >
        <!-- <img
          style=" float:left;width:150px;"
          src="https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/bd_logo1_31bdc765.png"
          alt="pic"
        />-->
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-xs-12 padding0"
          style="float: left;padding:5px;width: 180px"
        >
          <div class="swiper-container newswiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in newsSwiper" :key="index">
                <img :src="item.image" style="width: 200px" />
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: left;text-indent:2em;" v-html="item.brief"></div>
       <!--  <div style="position: absolute;bottom: 16px;right: 16px;">
          <div
            style="display: inline-block; cursor: pointer;background: #fff;"
            @click="download(item.coverId)"
          >
            <div style="display: inline-block;width: 30px;">
              <img src="../../static/img/index/xz_blue.png" width="80%" />
            </div>
            <span style="color: #3e7aff;">下载文件</span>
          </div>
        </div> -->
      </el-tab-pane>
    </el-tabs>
    <!--作品 End-->

    <!-- 赛事资讯 Start -->
    <div class="container" style="padding: 30px 10px 10px;align-items: normal;">
      <el-row>
        <el-col :span="7">
          <div>
            <span style="display: inline-block;width:8px; height: 26px;background: #7faeff"></span>
            <span
              style="display: inline-block;color: #005eff;vertical-align:top;margin-left: 10px;"
            >赛事资讯</span>
          </div>
        </el-col>
        <el-col :span="17">
          <el-button :type="raceNewsItemActive == 'Event News' ? 'primary' : ''" @click="getRaceNews('Event News')">赛事新闻</el-button>
          <el-button :type="raceNewsItemActive == 'Selection results' ? 'primary' : ''" @click="getRaceNews('Selection results')">视频中心</el-button>
          <el-button :type="raceNewsItemActive == 'Wonderful moment' ? 'primary' : ''" @click="getRaceNews('Wonderful moment')">精选图片</el-button>
        </el-col>
      </el-row>
      <div style="margin-top: 10px;">
        <el-row :gutter="10" style="height: 100%;" v-if="raceNewsItemActive == 'Event News'">
          <div  style="text-align: right; width: 100%; cursor: pointer; color: blue"  @click="toMediaCenter('Event News')" >
            更多>>>
          </div>
         <el-col :span="12" style="height: 100%;cursor: pointer;" v-for="item in raceNews.news.slice(0, 4)" :key="item.index">
            <div style="height: 100%" @click="toDetail(item.id)">
              <img :src="item.coverUrl" height="50%" width="100%" />
              <div
                style="
                      width: 100%;
                      height: 40px;
                      background: #fff;
                      padding: 2px;
                      text-align: left;
                      font-size: 12px;
                      float: left;
                      overflow: hidden;
                      text-overflow:ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                    "
                v-html="item.title"
              ></div>
              <div style="
                      width: 100%;
                      height: 10%;
                      background: #fff;
                      text-align: right;
                      font-size: 12px;
                      float: left;">
                <div style=" display: inline-block;color:#b1b6bb"><i class="el-icon-time"></i>{{item.releaseDate}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="height: 100%;" v-if="raceNewsItemActive == 'Selection results'">
          <div  style="text-align: right; width: 100%; cursor: pointer; color: blue"  @click="toMediaCenter('Selection results')" >
            更多>>>
          </div>
         <el-col :span="12" style="height: 100%;cursor: pointer;"  v-for="(itemVideo, index) in raceNews.videos.slice(0, 4)" :key="index">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="{
                //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如&quot;16:9&quot;或&quot;4:3&quot;）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                  {
                    type:
                      'video/mp4' ||
                      'video/x-flv' ||
                      'video/webm' ||
                      'video/ogg',
                    src: itemVideo.path, //url地址
                    // src: &quot;&quot; //url地址
                  },
                ],
                poster: itemVideo.coverUrl, //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '视频加载出错...', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                  timeDivider: true,
                  durationDisplay: true,
                  remainingTimeDisplay: false,
                  fullscreenToggle: true, //全屏按钮
                },
              }"
            ></video-player>
            <div
              :title="itemVideo.title"
              style="
                width: 100%;
                height: 45px;
                background: #fff;
                padding: 5px;
                text-align: left;
                font-size: 12px;
                float: left;
                overflow: hidden;
                text-overflow:ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              "
              v-html="itemVideo.title"
            ></div>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="height: 100%;" v-if="raceNewsItemActive == 'Wonderful moment'">
          <div  style="text-align: right; width: 100%; cursor: pointer; color: blue"  @click="toMediaCenter('Wonderful moment')" >
            更多>>>
          </div>
         <el-col :span="12" style="height: 100%;cursor: pointer;" v-for="item in raceNews.images.slice(0, 4)" :key="item.index">
            <div style="height: 100%">
                  <div style="width: 100%; height: 60%">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.coverUrl"
                      :preview-src-list="images"
                    >
                    </el-image>
                  </div>
                  <div
                    :title="item.title"
                    style="
                      width: 100%;
                      height: 40px;
                      background: #fff;
                      padding: 2px;
                      text-align: left;
                      font-size: 12px;
                      float: left;
                      overflow: hidden;
                      text-overflow:ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                    "
                    @click="toImageDetail(item.id)"
                  >{{item.title}}</div>
                  <div
                    style="
                      width: 100%;
                      height: 10%;
                      background: #fff;
                      text-align: right;
                      font-size: 12px;
                      float: left;
                    "
                  >
                    <div style="display: inline-block; color: #b1b6bb">
                      <i class="el-icon-time"></i>
                      {{ item.releaseDate }}
                    </div>
                  </div>
                </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 精彩集锦 End -->

    <!--  通知公告 Start  -->
    <div class="container" style="padding: 0">
      <img src="static/img/index/tzgg.png" width="100%" />
    </div>
    <el-tabs v-model="noticeActiveName" class="notice" @tab-click="handleClick">
      <el-tab-pane
        :label="item.title"
        :name="item.id+''"
        v-for="item in announcement"
        :key="item.id"
      >
        <div style="margin: 15px;padding: 15px 15px 55px 15px;border: 1px solid #3d8efd;background: #f6f9ff;">
          <div style="font-size: 32px">{{item.title}}</div>
          <div class="announcementContent" v-html="item.brief"></div>
        </div>
        <div style="position: absolute;bottom: 40px;right: 40px;">
          <div style="display: inline-block;cursor: pointer;" @click="trendsDetail(item.id)">
            <div style="display: inline-block;width: 30px;">
              <img src="../../static/img/index/info.png" width="80%" />
            </div>
            <span style="color: #bbb">查看详情</span>
          </div>
          <div style="display: inline-block;cursor: pointer;" @click="download(item.coverId)">
            <div style="display: inline-block;width: 30px;">
              <img src="../../static/img/index/xz_blue.png" width="80%" />
            </div>
            <span style="color: #bbb">下载文件</span>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!--  通知公告 End  -->

    <!-- 合作单位 Start -->
   <!--  <el-row :gutter="20" class="counit" style="margin: 0;">
      <el-col :span="24">
        <div>
          <span style="display: inline-block;width:8px; height: 26px;background: #7faeff"></span>
          <span
            style="display: inline-block;color: #005eff;vertical-align:super;margin-left: 10px;"
          >合作单位</span>
        </div>
      </el-col>
      <el-col :span="24" style="margin: 0px">
        <el-col :span="8" v-for="item in undertakeUnit" :key="item.id">
          <img :src="item.coverUrl" width="100%" style="margin-top: 30px;" />
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="8" v-for="item in subcontractor" :key="item.id">
          <img :src="item.coverUrl" width="100%" style="margin-top: 30px;" />
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="8" v-for="item in charitySponsorship" :key="item.id">
          <img :src="charitySponsorship[0].coverUrl" width="100%" style="margin-top: 30px;" />
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="8" v-for="item in charitySupport" :key="item.id">
          <img :src="item.coverUrl" width="100%" style="margin-top: 30px;" />
        </el-col>
      </el-col>
    </el-row> -->
    <!-- 合作单位 End -->

    <!-- footer Start -->
    <el-row :gutter="10" style="margin: 0;background: #4e4f50; color:#fff;padding: 20px;width: 100%;">
      <el-col :span="16">
        <div style="font-size: 22px;">{{ siteName }}官方网站</div>
        <div style="font-size: 14px;">地址：北京市朝阳区北辰东路5号</div>
        <div style="font-size: 14px;">电话：010-59041074</div>
      </el-col>
      <el-col :span="8">
        <div style="display:inline-block">
          <img src="../../static/img/index/ewm1.jpg" width="110" />
          <div style="text-align: center;">请关注我们</div>
        </div>
      </el-col>
    </el-row>
    <!-- footer End -->
  </div>
</template>

<script>
import {siteMess} from "@/api/system/index"
export default {
  data() {
    return {
      siteName:"",
       images: [],
      banners: [],
      activeName: "",
      compotiiton: [],
      raceNews: {
        news:[],
        videos:[],
        images:[]
      },
      raceNewsItemActive: '',
      noticeActiveName: undefined,
      announcement: [],
      undertakeUnit: [],
      subcontractor: [],
      charitySponsorship: [],
      charitySupport: [],
      newsSwiper: [
        {
          image: ".../../static/img/news.png"
        }
      ]
    };
  },
  created () {
    siteMess(this.siteURL,this.siteId).then(res=>{
      this.siteName = res.data.name;
    })
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      //banner
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Banner";
      this.axios.get(api, {}).then((response) => {
        this.banners = response.data.rows;
      });

      //创新实验暨作品
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Innovative experiments";
      this.axios.get(api, {}).then((response) => {
        this.compotiiton = response.data.rows;
        this.activeName = this.compotiiton[0].title;
      });

      //赛事资讯
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Event News";
      this.axios.get(api, {}).then((response) => {
        this.raceNews.news = response.data.rows;
      });
      //视频中心
      var api =this.siteURL + "/actuator/article/selectArticleFile?siteId="+this.siteId+"&nameEn=Selection results";
      this.axios.get(api, {}).then((response) => {
        this.raceNews.videos = response.data.rows;
      });
      //精品图片
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Wonderful moment";
      this.axios.get(api, {}).then((response) => {
        this.raceNews.images = response.data.rows;
        this.images = [];
        this.raceNews.images.forEach((item) => this.images.push(item.coverUrl));
      });
      //通知公告
      var url =
        this.siteURL +
        "/actuator/channel/list?siteId=" +
        this.siteId +
        "&url=/indexTrends";
      this.axios.get(url, {}).then(response => {
        this.channelId = response.data.rows[0].id;
        var api =
          this.siteURL + "/actuator/article/list?channelId=" + this.channelId;
        this.axios.get(api, {}).then(response => {
          this.announcement = response.data.rows;
          this.noticeActiveName = this.announcement[0].id+"";
        });
      });

      //主办单位
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Organizer";
      this.axios.get(api, {}).then((response) => {
        this.hostUnit = response.data.rows;
      });

      //承办单位
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Organ";
      this.axios.get(api, {}).then((response) => {
        this.undertakeUnit = response.data.rows;
      });

      //分赛区承办
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Organized by sub-region";
      this.axios.get(api, {}).then((response) => {
        this.subcontractor = response.data.rows;
      });

      //独家公益赞助
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Exclusive charity sponsorship";
      this.axios.get(api, {}).then((response) => {
        this.charitySponsorship = response.data.rows;
      });

      //公益支持单位
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=Charity support unit";
      this.axios.get(api, {}).then((response) => {
        this.charitySupport = response.data.rows;
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getRaceNews(nameEn) {
      this.raceNewsItemActive = nameEn;
      // //赛事资讯
      // var api = this.siteURL + "/actuator/article/listAndFile?channelId=" + channelId;
      // this.axios.get(api, {}).then(response => {
      //   this.raceNews = response.data.rows;
      //   this.images = [];
      //   this.raceNews.forEach((item) => this.images.push(item.coverUrl));
      // });
    },
     toMediaCenter(e) {
      let routeUrl = this.$router.resolve({
        path: "/mediaCenter",
        query: { nameEn: e },
      });
      window.open(routeUrl.href, "_blank");
    },
        toImageDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/imageDetail",
        query: { id: e },
      });
      window.open(routeUrl.href, "_blank");
    },
    download(coverId) {
      if (coverId === undefined || coverId === null) {
        this.$message("没有文件可下载");
        return;
      }
      var api = this.siteURL + "/actuator/storage/" + coverId;
      this.axios.get(api, {}).then(response => {
        let fileUrl = response.data.data.fileName;
        var downUrl = this.siteURL + "/actuator/storage/download/" + coverId;
        this.axios.defaults.headers.post["Content-Type"] =
          "application/x-www-form-urlencoded";
        this.axios({
          method: "post",
          url: downUrl,
          responseType: "blob"
        }).then(res => {
          let data = res.data;
          if (!data) {
            return;
          }
          const blob = new Blob([data]);
          // 其他非IE内核支持H5的浏览器
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileUrl);
          document.body.appendChild(link);
          link.click();
        });
      });
    },
    trendsDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: { id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    toDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: { id: e }
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style scoped>
.el-button {
  padding: 8px 10px;
}

.el-button + .el-button {
  margin-left: 0px;
}
</style>
<style>
.phone .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}

.phone .el-tabs__item {
  padding: 0 18px;
}

.phone .notice .el-tabs__nav {
  width: 100%;
  background: #e5effe;
}

.phone .el-tabs__header {
  margin: 0;
}

.phone .el-tabs__content {
  padding: 10px;
  background: #f8f8f8;
}
.phone .vjs-custom-skin > .video-js .vjs-big-play-button {
  font-size: 1.5em;
}
.phone .vjs-custom-skin > .video-js .vjs-control-bar {
  font-size: 8px !important;
}
.phone .vjs-custom-skin > .video-js .vjs-play-progress:before {
  top: -0.6em;
}
.phone .vjs-slider-horizontal .vjs-volume-level:before {
  top: -0.6em;
  right: -0.5em;
}
.phone .vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-playback-rate
  .vjs-playback-rate-value {
  font-size: 1.2em;
  line-height: 1.9;
}
.phone .marginVideo {
  margin: 0 30px;
}
.el-tabs__nav-wrap.is-scrollable {
  padding: 0 25px;
}
.el-tabs__nav-prev {
  font-size: 25px;
}
.el-tabs__nav-next {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/Phone.vue